import React, {useState} from "react";
import {Input, ScrollArea, Table, Text, Title} from "@mantine/core";


interface Winner {
    id: number;
    prize: string;
    name: string;
    phone: string;
    code: string;
}

const data: Winner[] = [
    { id: 1, prize: 'Put na Tasos za 2 osobe', name: 'Dragan Marković', phone: '***623', code: '4T39JWGR-4T39JWGR-9522' },
    { id: 2, prize: 'TV', name: 'Aleksandar Nedeljković', phone: '***551', code: 'LUR6YYQ6-LUR6YYQ6-9284' },
    { id: 3, prize: 'Bicikl', name: 'Bojana Vucetic', phone: '***317', code: 'F42Q35XY-F42Q35XY-10423' },
    { id: 4, prize: 'Airfryer', name: 'Vanja Cirakovic', phone: '***003', code: '4T39JWGR-4T39JWGR-10394' },
    { id: 5, prize: 'Airfryer', name: 'Milica Todorović', phone: '***605', code: '5P4PLZ9L-5P4PLZ9L-12053' },
    { id: 6, prize: 'Airfryer', name: 'Pavle Jovanovic', phone: '***764', code: '6G7HPK24-6G7HPK24-5470' },
    { id: 7, prize: 'Airfryer', name: 'Dejan Knežević', phone: '***211', code: '6G7HPK24-6G7HPK24-9970' },
    { id: 8, prize: 'Nutribullet', name: 'Branko Makević', phone: '***600', code: 'VENS5BCE-VENS5BCE-7879' },
    { id: 9, prize: 'Nutribullet', name: 'Aleksandra Džagić', phone: '***620', code: '4T39JWGR-4T39JWGR-10716' },
    { id: 10, prize: 'Nutribullet', name: 'Sonja Adamović', phone: '***152', code: '4T39JWGR-4T39JWGR-9511' },
    { id: 11, prize: 'Nutribullet', name: 'Dejan Knežević', phone: '***211', code: '6YG7HPK2-6G7HPK24-6387' },
    { id: 12, prize: 'Nutribullet', name: 'Dusko Bojic', phone: '***001', code: '6G7HPK24-6G7HPK24-9019' },
    { id: 13, prize: 'Džezva', name: 'Dejan Lazić', phone: '***996', code: '4T39JWGR-4T39JWGR-8120' },
    { id: 14, prize: 'Džezva', name: 'Verica Jovičić', phone: '***863', code: '42Z7MWGU-42Z7MWGU-9495' },
    { id: 15, prize: 'Džezva', name: 'Milan Jovanovic', phone: '***625', code: '4T39JWGR-4T39JWGR-7362' },
    { id: 16, prize: 'Džezva', name: 'Kristina Suvajdzic', phone: '***022', code: 'VENS5BCE-VENS5BCE-7735' },
    { id: 17, prize: 'Džezva', name: 'Dragan Jovanović', phone: '***334', code: '5P4PLZ9L-5P4PLZ9L-10899' },
    { id: 18, prize: 'Džezva', name: 'Ljiljana Isailović', phone: '***189', code: '4ZCLU3DN-4ZCLU3DN-13448' },
    { id: 19, prize: 'Džezva', name: 'Vladimir Stanojčić', phone: '***362', code: '5D9E5E2V-5D9E5E2V-46160' },
    { id: 20, prize: 'Džezva', name: 'Zorana Rakic', phone: '***548', code: '4ZCLU3DN-4ZCLU3DN-9263' },
    { id: 21, prize: 'Džezva', name: 'Sanja Stojanović', phone: '***319', code: '5P4PLZ9L-5P4PLZ9L-11005' },
    { id: 22, prize: 'Džezva', name: 'Dejan Knežević', phone: '***211', code: '6G7HPK24-6G7HPK24-12407' },
    { id: 23, prize: 'Toster', name: 'Una Drageljević', phone: '***101', code: 'ATWB39AR-ATWB39AR-10052' },
    { id: 24, prize: 'Toster', name: 'Marije Vasiljević', phone: '***532', code: 'LUR6YYQ6-LUR6YYQ6-11518' },
    { id: 25, prize: 'Toster', name: 'Biljana Stamenkovic', phone: '***436', code: 'F42035XY-F42035XY-6679' },
    { id: 26, prize: 'Toster', name: 'Dusko Bojic', phone: '***001', code: '6G7HPK24-6G7HPK24-9815' },
    { id: 27, prize: 'Toster', name: 'Julijana Petrovic', phone: '***455', code: '42Z7MWGV-42Z7MWGV-9045' },
    { id: 28, prize: 'Toster s', name: 'Nevena Tadic', phone: '***083', code: '4T39JWGR-4T39JWGR-13112' },
    { id: 29, prize: 'Toster s', name: 'Milijana Samurović', phone: '***002', code: 'BZSU8WGP-BZSU8WGP-16689' },
    { id: 30, prize: 'Tacna keramička', name: 'Ivana Slavkovic', phone: '***544', code: 'ATWB39AR-ATWB39AR-8659' },
    { id: 31, prize: 'Tacna keramička', name: 'Tanja Mijailović', phone: '***108', code: 'VENS5BCE-VENS5BCE-7673' },
    { id: 32, prize: 'Tacna keramička', name: 'Nikola Živanović', phone: '***862', code: 'Y6RLZAAJ-Y6RLZAAJ-2758' },
    { id: 33, prize: 'Tacna keramička', name: 'Milena Stojicevic', phone: '***046', code: '4T39JWGR-4T39JWGR-12877' },
    { id: 34, prize: 'Tacna keramička', name: 'Živko Brajić', phone: '***473', code: '4T39JWGR-4T39JWGR-9477' },
    { id: 35, prize: 'Šoljice za kafu', name: 'Darko Djurdjevic', phone: '***068', code: 'CBNP8PU3-CBNP8PU3-8142' },
    { id: 36, prize: 'Šoljice za kafu', name: 'Snežana Milisavljević', phone: '***270', code: '6G7HPK24-6G7HPK24-10681' },
    { id: 37, prize: 'Šoljice za kafu', name: 'Ljilja Reljic', phone: '***207', code: 'TW5K4FAR-TW5K4FAR-26080' },
    { id: 38, prize: 'Šoljice za kafu', name: 'Mirjana Petrovic', phone: '***385', code: '4T39JWGR-4T39JWGR-12025' },
    { id: 39, prize: 'Šoljice za kafu', name: 'Ana Topalović', phone: '***623', code: '42Z7MWGV-42Z7MWGV-11705' },
    { id: 40, prize: 'Šoljice za kafu', name: 'Vanja Cirakovic', phone: '***003', code: '4T39JWGR-4T39JWGR-11786' },
    { id: 41, prize: 'Šoljice za kafu', name: 'Nataša Stepanović', phone: '***234', code: 'BZSU8WGP-BGSU8WGP-22170' },
    { id: 42, prize: 'Šoljice za kafu', name: 'Natasa Vasilic', phone: '***618', code: 'BZSU8WGP-BZSU8WGP-22947' },
    { id: 43, prize: 'Šoljice za kafu', name: 'Sandra Teodosic', phone: '***775', code: '5P4PLZ9L-5P4PLZ9L-7010' },
    { id: 44, prize: 'Šoljice za kafu', name: 'Ana Paranosic', phone: '***355', code: '42Z7MWEU-42Z7MWGU-8320' },
    { id: 45, prize: 'Šoljice za kafu', name: 'Isidora Jankovic', phone: '***971', code: 'ATWB39AR-ATWB3AR9-896' },
    { id: 46, prize: 'Majica', name: 'Nebojša Žunić', phone: '***456', code: 'F42Q35XY-F42Q35XY-7983' },
    { id: 47, prize: 'Majica', name: 'Bojana Sredojević', phone: '***015', code: '42Z7MWGV-42Z7MWGV-12594' },
    { id: 48, prize: 'Majica', name: 'Gorica Dimitrijevic', phone: '***095', code: 'BZSU8WGP-BZSU8WGP-12447' },
    { id: 49, prize: 'Majica', name: 'Zorica Josipović', phone: '***777', code: '4T39JWGR-4T39JWGR-7839' },
    { id: 50, prize: 'Majica', name: 'Vladimir Stanojčić', phone: '***362', code: '6G7HPK24-6G7HPK24-12056' },
    { id: 51, prize: 'Majica', name: 'Nemanja Petrovića', phone: '***850', code: '4ZCLU3DN-4ZCLU3DN-9701' },
    { id: 52, prize: 'Majica', name: 'Nebojša Žunić', phone: '***456', code: 'VWNS5BCE-VEBS5BCE-9626' },
    { id: 53, prize: 'Majica', name: 'Sladjana Mitrović', phone: '***563', code: '4T39JWGR-4T39JWGR-9015' },
    { id: 54, prize: 'Majica', name: 'Zorica Bogojevic', phone: '***416', code: 'VENS5BCE-VENS5BCE-10355' },
    { id: 55, prize: 'Majica', name: 'Nikola Stankovic', phone: '***091', code: 'BZSU8WGP-BZSU8WGP-18462' },
    { id: 56, prize: 'Majica', name: 'Dragan gatić', phone: '***570', code: '4T39JWGR-4T39JWGR-12494' },
    { id: 57, prize: 'Majica', name: 'Milutin Tešić', phone: '***012', code: 'VENS5BCE-VENS5BCE-8738' },
    { id: 58, prize: 'Majica', name: 'Zoran Stošić', phone: '***340', code: '4ZCLU3DN-4ZCLU3DN-13905' },
    { id: 59, prize: 'Majica', name: 'Nikola Pekmezović', phone: '***318', code: '4T39JWGR-4T39JWGR-12981' },
    { id: 60, prize: 'Majica', name: 'Slavica Vladisavljević', phone: '***925', code: '6G7HPK24-6G7HPK24-9196' },
    { id: 61, prize: 'Majica', name: 'Dejan Knežević', phone: '***211', code: '6G7HPK24-6G7HPK24-9269' },
    { id: 62, prize: 'Majica', name: 'Biljana Milovanovic', phone: '***499', code: 'BZSU8WGP-BZSU8WGP-18177' },
    { id: 63, prize: 'Majica', name: 'Sanja Vićić', phone: '***811', code: 'F4M8LZUC-F4M8LZUC-6694' },
    { id: 64, prize: 'Majica', name: 'Bojana Bojic', phone: '***379', code: '6G7HPK24-6G7HPK24-7076' },
    { id: 65, prize: 'Majica', name: 'Milica Kostadinović', phone: '***161', code: 'VENS5BCE-VENS5BCE-8722' },
    { id: 66, prize: 'Majica', name: 'Kristina Suvajdzic', phone: '***022', code: 'F42Q35XY-F42Q35XY-10199' },
    { id: 67, prize: 'Majica', name: 'Milan Marić', phone: '***353', code: '42Z7MWGV-42Z7MWGV-9315' },
    { id: 68, prize: 'Majica', name: 'Tatjana Petrovic', phone: '***729', code: 'F42Q35XY-F42Q35XY-9630' },
    { id: 69, prize: 'Majica', name: 'Vanja Cirakovic', phone: '***003', code: '4T39JWGR-4T39JWGR-10829' },
    { id: 70, prize: 'Majica', name: 'Katarina Malic', phone: '***344', code: 'ATWB39AR-ATWB39AR-10970' },
    { id: 71, prize: 'Majica', name: 'Nikola Babić', phone: '***265', code: 'BZSU8WGP-BZSU8WGP-16835' },
    { id: 72, prize: 'Majica', name: 'Tamara Veselinovic', phone: '***655', code: 'ATWB39AR-ATWB39AR-9377' },
    { id: 73, prize: 'Majica', name: 'Ivana Gajic', phone: '***490', code: '6G7HPK24-6G7HPK24-12029' },
    { id: 74, prize: 'Majica', name: 'Ljiljana Mijailovic', phone: '***803', code: 'VENS5BCE-VENS5BCE-13217' },
    { id: 75, prize: 'Majica', name: 'Milojko Obrenović', phone: '***460', code: 'ATWB39AR-ATWB39AR-10742' },
    { id: 76, prize: 'Majica', name: 'Svetlana Čamdžić', phone: '***510', code: '6G7HPK24-6G7HPK24-11019' },
    { id: 77, prize: 'Majica', name: 'Slaviša Ilić', phone: '***781', code: '4T39JWGR-4T39JWGR-10787' },
    { id: 78, prize: 'Majica', name: 'Danijela Antonic', phone: '***721', code: 'QQY4V7FZ-QQY4V7FZ-10011' },
    { id: 79, prize: 'Majica', name: 'Sreten Pantelić', phone: '***834', code: 'YGQB63ZQ-YGQB63ZQ-10420' },
    { id: 80, prize: 'Majica', name: 'Katarina Petrović', phone: '***828', code: 'BZSU8WGP-BZSU8WGP-16505' },
    { id: 81, prize: 'Majica', name: 'Nenad Tadić', phone: '***552', code: 'VENS5BCE-VENS5BCE-8441' },
    { id: 82, prize: 'Majica', name: 'Boljana Maksimovic', phone: '***203', code: '5D9E5E2V-5D9E5E2V-44503' },
    { id: 83, prize: 'Majica', name: 'Zorica Đorđić', phone: '***694', code: 'VENS5BCE-VENS5BCE-8133' },
    { id: 84, prize: 'Majica', name: 'Maja Čupić', phone: '***503', code: '4T39JWGR-4T39JWGR-9021' },
    { id: 85, prize: 'Majica', name: 'Vladimir Gligoric', phone: '***180', code: '5P4PLZ9L-5P4LZ9L1-3749' },
    { id: 86, prize: 'Majica', name: 'Vera Milošević', phone: '***148', code: 'BQF5RH7Z-BQF5RH7Z-4999' },
    { id: 87, prize: 'Majica', name: 'Zlatomir Djukanovic', phone: '***714', code: 'LUR6YYQ6-LUR6YYQ6-8624' },
    { id: 88, prize: 'Majica', name: 'Dejan Kostić', phone: '***200', code: 'CBNP8PU3-CBNP8PU3-7641' },
    { id: 89, prize: 'Majica', name: 'Andrea Stankovic', phone: '***999', code: '42Z7MWGV-42Z7MWGV-8389' },
    { id: 90, prize: 'Majica', name: 'Ana Rakić', phone: '***257', code: 'S3FSLJCS-S3FSLJCS-8694' },
    { id: 91, prize: 'Majica', name: 'Irena Živanović', phone: '***862', code: 'Y6RLZAAJ-Y6RLZAAJ-3094' },
    { id: 92, prize: 'Majica', name: 'Marijana Stevanović', phone: '***648', code: 'ATWB39AR-ATWB39AR-10056' },
    { id: 93, prize: 'Majica', name: 'Branko Mišić', phone: '***802', code: 'BZSU8WGP-BZSU8WGP-20020' },
    { id: 94, prize: 'Majica', name: 'Vladimir Taborovic', phone: '***704', code: 'BZSU8WGP-BZSU8WGP-12349' },
    { id: 95, prize: 'Majica', name: 'Slavica Bogdanovic', phone: '***216', code: '5D9E5E2V-5D9E5E2V-44609' },
    { id: 96, prize: 'Majica', name: 'Milica Jakelj', phone: '***844', code: 'F42Q35XY-F42Q35XY-9523' },
    { id: 97, prize: 'Majica', name: 'Angelina Markovic', phone: '***180', code: '4ZCLU3DN-4ZCLU3DN-8933' },
    { id: 98, prize: 'Majica', name: 'Zorica Lazic', phone: '***141', code: 'Y6RLZAAJ-Y6RLZAAJ-3196' },
    { id: 99, prize: 'Majica', name: 'Stana Urošević', phone: '***550', code: '5P4PLZ9L-5P4PLZ9L-9520' },
    { id: 100, prize: 'Majica', name: 'Ivan Vujić', phone: '***789', code: '4ZCLU3DN-4ZCLU3DN-13880' },
    { id: 101, prize: 'Majica', name: 'Jovana Bajić', phone: '***987', code: '6G7HPK24-6G7HPK24-5995' },
    { id: 102, prize: 'Majica', name: 'Gorica Matić', phone: '***690', code: '6G7HPK24-6G7HPK24-9328' },
    { id: 103, prize: 'Majica', name: 'Mladen Vicentic', phone: '***080', code: '8QF5RH7Z-8QF5RH7Z-3731' },
    { id: 104, prize: 'Majica', name: 'Momir Jokić', phone: '***927', code: 'ATWB39AR-ATWB39AR-10852' },
    { id: 105, prize: 'Majica', name: 'Bojana Milošević', phone: '***182', code: '4ZCLU3DN-4ZCLU3DN-9615' },
    { id: 106, prize: 'Paketi Promeks', name: 'Marija Taborovic', phone: '***036', code: 'BZSU8WGP-BZSU8WGP-17971' },
    { id: 107, prize: 'Paketi Promeks', name: 'Dragica Sremčević', phone: '***900', code: '4ZCLU3DN-4ZCLU3DN-13483' },
    { id: 108, prize: 'Paketi Promeks', name: 'Svetlana Gajić', phone: '***859', code: '6G7HPK24-6G7HPK24-11599' },
    { id: 109, prize: 'Paketi Promeks', name: 'Rajka Jovic', phone: '***565', code: '5P4PLZ9L-5P4PLZ9L-9031' },
    { id: 110, prize: 'Paketi Promeks', name: 'Milica Jovanovic', phone: '***104', code: '42Z7MWGV-42Z7MWGV-9967' },
    { id: 111, prize: 'Paketi Promeks', name: 'Bojana Sredojević', phone: '***015', code: '42Z7MWGV-42Z7MWGV-10911' },
    { id: 112, prize: 'Paketi Promeks', name: 'Snezana Bijuklic', phone: '***315', code: 'LUR6YYQ6-LUR6YYQ6-12052' },
    { id: 113, prize: 'Paketi Promeks', name: 'Mirjana Jeremic', phone: '***803', code: 'VENS5BCE-VENS5BCE-9970' },
    { id: 114, prize: 'Paketi Promeks', name: 'Vanja Cirakovic', phone: '***003', code: '4T39JWGR-4T39JWGR-12518' },
    { id: 115, prize: 'Paketi Promeks', name: 'Ljubica Mrgud', phone: '***366', code: 'YGQB63ZQ-YGQB63ZQ-13110' },
    { id: 116, prize: 'Paketi Promeks', name: 'Vesna Marinkovic', phone: '***982', code: '4T39JWGR-4T39JWGR-10365' },
    { id: 117, prize: 'Paketi Promeks', name: 'Jelena Robinić', phone: '***408', code: '42Z7MWGV-42Z7MWGV-10476' },
    { id: 118, prize: 'Paketi Promeks', name: 'Bojana Čačić', phone: '***777', code: '4277MWGV-4277MWGV-10537' },
    { id: 119, prize: 'Paketi Promeks', name: 'Dragan Simić', phone: '***465', code: 'F42Q35XY-F42Q35XY-9327' },
    { id: 120, prize: 'Paketi Promeks', name: 'Nikola Andjelic', phone: '***321', code: 'S3FSLJCS-S3FSLJCS-5990' },
    { id: 121, prize: 'Paketi Promeks', name: 'Jelena Adamović', phone: '***480', code: '42Z7MWGV-42Z7MWGV-9559' },
    { id: 122, prize: 'Paketi Promeks', name: 'Vesna Mihajlovic', phone: '***050', code: '4T39JWGR-4T39JWGR-6973' },
    { id: 123, prize: 'Paketi Promeks', name: 'Jelisaveta Teodora Gajić', phone: '***230', code: '5P4PLZ9L-5P4PLZ9L-12320' },
    { id: 124, prize: 'Paketi Promeks', name: 'Branko Mišić', phone: '***802', code: 'VENS5BCE-VENS5BCE-11402' },
    { id: 125, prize: 'Paketi Promeks', name: 'Tatjana Trifunović', phone: '***963', code: 'F42Q35XY-F42Q35XY-6867' },
    { id: 126, prize: 'Paketi Promeks', name: 'Nikola Lukic', phone: '***133', code: '4T39JWGR-4T39JWGR-7309' },
    { id: 127, prize: 'Paketi Promeks', name: 'Jovana Bajić', phone: '***987', code: 'ATWB39AR-ATWB39AR-9585' },
    { id: 128, prize: 'Paketi Promeks', name: 'Bojana Madžarević', phone: '***559', code: 'F4M8LZUC-F4M8LZUC-7261' },
    { id: 129, prize: 'Paketi Promeks', name: 'Mateja Petrovic', phone: '***302', code: '5P4PLZ9L-5P4PLZ9L-9673' },
    { id: 130, prize: 'Paketi Promeks', name: 'Katarina Arsenovic', phone: '***130', code: 'Y6RLZAAJ-Y6RLZAAJ-3789' },
    { id: 131, prize: 'Paketi Promeks', name: 'Sanja Matić', phone: '***158', code: '5P4PLZ9L-5P4PLZ9L-8600' },
    { id: 132, prize: 'Paketi Promeks', name: 'Dejan Knežević', phone: '***211', code: '6G7HPK24-6G7HPK24-8533' },
    { id: 133, prize: 'Paketi Promeks', name: 'Daliborka Grujicic', phone: '***040', code: 'S3FSLJCS-S3FSLJCS-6889' },
    { id: 134, prize: 'Paketi Promeks', name: 'Svetlana Gajić', phone: '***859', code: '6G7HPK24-6G7HPK24-12256' },
    { id: 135, prize: 'Paketi Promeks', name: 'Jelena Robinić', phone: '***408', code: '42Z7MWGV-42Z7MWGV-13355' }
];


const ParticipantForm: React.FC = () => {

    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState<Winner[]>(data);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearch(value);
        setFilteredData(
            data.filter(
                (item) =>
                    item.name.toLowerCase().includes(value.toLowerCase()) ||
                    item.prize.toLowerCase().includes(value.toLowerCase()) ||
                    item.phone.includes(value) ||
                    item.code.toLowerCase().includes(value.toLowerCase())
            )
        );
    };

    return (
        <div className="bg-white min-h-screen flex flex-col justify-between">
            <div className=" w-full overflow-hidden absolute">
                {/* <img className="max-w-none lg:w-full" src="/assets/Bubbles.svg" alt="baloncici" /> */}
                <img
                    className="max-w-none lg:w-full -mt-24"
                    src="/assets/Bubbles.svg"
                    alt="baloncici"
                />
            </div>

            <div className="z-20">
                {/* HEADER */}

                <header className="w-full h-48 flex items-center justify-between px-3 lg:px-12">
                    {/* Levo */}
                    <div className="h-1/3 lg:block flex justify-center">
                        <img
                            className="h-full object-cover block"
                            src="/assets/coffee-bean_icon.svg"
                            alt="coffee"
                        />
                    </div>

                    <div
                        className="cursor-pointer px-3 -ml-12 lg:ml-0 -mt-20 lg:-mt-10 h-full flex justify-center">
                    </div>

                    <div
                        className="cursor-pointer  px-3 -mt-20 lg:-mt-10 h-full flex justify-center -ml-36 lg:ml-0">
                    </div>

                    {/* Desno */}
                    <div className="h-full flex items-center ">
                        <a
                            href="https://www.promeks.co.rs/o-nama"
                            target="_blank"
                            rel="noopener noreferrer">
                            <img
                                className=""
                                src="/assets/promeks_baner.png"
                                alt="promeks baner"
                            />
                        </a>
                    </div>
                </header>

                <main className="flex flex-col items-center justify-center mb-5 -mt-12 lg:-mt-24 ">
                    <div className="mb-4">
                        <img src="/assets/promeks_logo.png" alt="promeks logo"/>
                    </div>

                    <div className="text-center text-gray-700 -mb-10 font-medium">
                        <div className="my-5">
                            <Text className="italic ">Poklanjanje je završeno. Hvala svima koji su učestvovali!</Text>
                        </div>
                        <Title order={1}>DOBITNICI</Title>
                        <div className=" mb-20">
                            <Input
                                placeholder="Pretraži ime, nagradu, telefon ili kod"
                                value={search}
                                onChange={handleSearch}
                                className="mb-4 p-4"
                            />
                            <ScrollArea h={400} >
                                <Table striped highlightOnHover withTableBorder withColumnBorders>
                                    <Table.Thead>
                                        <Table.Tr>
                                            <Table.Th>#</Table.Th>
                                            <Table.Th>Nagrada</Table.Th>
                                            <Table.Th>Ime i prezime</Table.Th>
                                            <Table.Th>Telefon</Table.Th>
                                            <Table.Th>Kod</Table.Th>
                                        </Table.Tr>
                                    </Table.Thead>
                                    <Table.Tbody>
                                        {filteredData.map((winner) => (
                                            <Table.Tr key={winner.id}>
                                                <Table.Td>{winner.id}</Table.Td>
                                                <Table.Td>{winner.prize}</Table.Td>
                                                <Table.Td>{winner.name}</Table.Td>
                                                <Table.Td>{winner.phone}</Table.Td>
                                                <Table.Td>{winner.code}</Table.Td>
                                            </Table.Tr>
                                        ))}
                                    </Table.Tbody>
                                </Table>
                            </ScrollArea>
                        </div>
                    </div>

                </main>
            </div>

            {/* FIXED BALONČIĆI NA DNU */}
            {/* BUBBLE FOOTER FIXED */}
            <div className=" -mt-5  lg:-mt-16 ">
                {/* <img className="max-w-none lg:w-full object-cover" src="/assets/Bubbles.svg" alt="baloncici" /> */}
                <img className="w-full" src="/assets/kafidzonka2.svg" alt="zrna kafe"/>
            </div>
        </div>
    );
};

export default ParticipantForm;
